import { useEffect, useState } from "react";

const useModal = (visible?: boolean, delay?: number, closeDelay?: number) => {
  const [shouldVisible, setShouldVisible] = useState<boolean>(false);

  useEffect(() => {
    if (visible) {
      const id = setTimeout(() => setShouldVisible(true), delay);
      return () => clearTimeout(id);
    } else if (closeDelay) {
      const id = setTimeout(() => setShouldVisible(false), closeDelay);
      return () => clearTimeout(id);
    } else setShouldVisible(false);
  }, [visible]);

  return { shouldVisible };
};

export default useModal;
